import VueAvatar from './components/VueAvatar.vue';
import VueAvatarEditor from './components/VueAvatarEditor.vue';
export default VueAvatarEditor;

export { VueAvatar, VueAvatarEditor };